const CheckedIcon = (props) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5499 3.16477C22.0112 3.46847 22.1389 4.08861 21.8352 4.5499L10.6429 21.5499C10.4713 21.8105 10.188 21.976 9.87677 21.9976C9.56555 22.0192 9.2621 21.8943 9.05624 21.6599L2.24861 13.9079C1.88418 13.4929 1.92516 12.8611 2.34014 12.4966C2.75512 12.1322 3.38696 12.1732 3.75139 12.5882L9.6936 19.3547L20.1648 3.45011C20.4685 2.98882 21.0886 2.86107 21.5499 3.16477Z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CheckedIcon;